module.exports = __webpack_public_path__ + "img/366.6e0a3515.png";